// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getEndDateProfile(projectId: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/weekly/end_date_profile`);
}
